import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import I18nInput from '../input/i18n'
import SelectInput from '../input/select'
import { Checkbox, OverlayTrigger, Popover } from 'react-bootstrap'

const EnumsSetEditForm = observer(({ store }) => {
  const entity = store.cv.record
  const errors = store.cv.errors
  const updateField = store.cv.updateData.bind(store.cv)
  const entityName = store.router && store.router.params && store.router.params.entityname
  const disabled = !store.hasRight(entityName, 'w')
  const hasID = entity.has('id') && entity.get('id')
  const tablang = store.langtab ||
    (store.router && store.router.queryParams && store.router.queryParams._langtab)

  function makeSlug (value) {
    return entityName === linkConst.LINK_TIERS_SETTINGS
      ? value.replace(/[^a-zA-Z0-9 -]/g, '')
        .replace(/\b\w/g, l => l.toUpperCase())
        .replace(/\s+/g, '')
        .replace(/-+/g, '-')
      : value.toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
    // .replace(/^-+/, '').replace(/-+$/, '')
  }

  function handleRemove (row) {
    const params = ['transls', row, store.modalEntity && entity.get('transls')]
    store.modalEntity
      ? store.cv.removeyRow(...params)
      : store.removeArrayRow(...params)
  }

  function handleAdd (lang) {
    let name = ''
    if (entity.has('fp_platform_code') && entity.get('fp_platform_code')) {
      name = store.options.get('FlyPrivatePlatforms').find(i => i.value === entity.get('fp_platform_code'))
    }
    const params = ['transls', { lang, value: name ? name.text + ' - ' : name }, store.modalEntity && entity.get('transls')]
    store.modalEntity
      ? store.cv.addRow(...params)
      : store.addArrayRow(...params)
  }

  function handleChange (lang, value) {
    const params = ['transls', { lang }, value, store.modalEntity && entity.get('transls')]
    store.modalEntity
      ? store.cv.changeValue(...params)
      : store.changeAttrArrayValue(...params)
    if (entity.get('checkAuto') && lang === 'en') {
      entity.set('value', makeSlug(value))
      store.cv.updateData('value', makeSlug(value))
    }
  }

  function handleSelectChange (attr, value) {
    entity.set(attr, value)
    const name = store.options.get('FlyPrivatePlatforms').find(i => i.value === value)
    entity.get('transls').map(i => {
      const params = ['transls', { lang: i.lang }, name.text + ' - ', store.modalEntity && entity.get('transls')]
      store.modalEntity
        ? name && store.cv.changeValue(...params)
        : name && store.changeAttrArrayValue(...params)
      if (i.lang === 'en') {
        store.cv.updateData('value', makeSlug(value) + '-')
      }
    })
  }

  function handleCheckboxChange () {
    const checked = !entity.get('checkAuto')
    entity.set('checkAuto', checked)

    checked && entity.get('transls').map(i => {
      if (i.lang === 'en') {
        store.cv.updateData('value', makeSlug(i.value))
      }
    })
  }

  function listOfCategories (value) {
    return value && store.options.has('FlyprivateCategories') && <div><strong>{store.__('List of current categories:')}</strong><br />
      <ul>{store.options.get('FlyprivateCategories')
        .filter(v => v.value.toLowerCase().indexOf(value.toLowerCase()) >= 0)
        .map((v, k) => <OverlayTrigger key={k} trigger={['hover', 'focus']} placement='left'
          overlay={<Popover>{v.value}</Popover>}>
          <li>{v.text}</li>
        </OverlayTrigger>
        )}
      </ul></div>
  }

  function listOfTiers (value) {
    const found = value && store.options.get('PricingTiers')
      .filter(v => v.value.toLowerCase().indexOf(value.toLowerCase()) >= 0)
      .map((v, k) => <OverlayTrigger key={k} trigger={['hover', 'focus']} placement='left'
        overlay={<Popover>{v.value}</Popover>}>
        <li>{v.text} </li>
      </OverlayTrigger>
      )

    return value && store.options.has('PricingTiers') &&
      <div><strong>{store.__('List of current tiers with a similar name:')}</strong><br />
        {found && found.length > 0 ? <ul>{found}</ul> : <em>- {store.__('nothing found')} -</em>}</div>
  }

  return (
    <div className='row'>
      <Helmet title={store.__(linkConst.LINKS_LIST[entityName]).concat(defaultConst.HTML_DIVIDER) + (entity.has('id')
        ? ((entity.has('transls') && entity.get('transls') && entity.get('transls')[0] && entity.get('transls')[0].value) || store.__(defaultConst.TITLE_EDIT))
        : store.__(defaultConst.TITLE_CREATE))} />
      <div className='col-xs-12 col-sm-9 col-md-6'>
        {(entityName !== linkConst.LINK_TIERS_SETTINGS && entityName !== linkConst.LINK_FILMS) && !hasID &&
        <SelectInput
          label={store.__('platform')}
          attr={'fp_platform_code'}
          record={entity}
          labelattr='text'
          valueattr='value'
          errors={errors}
          onChange={(val, v) => handleSelectChange(val, v)}
          optionsrecord={store.options}
          optionsattr={'FlyPrivatePlatforms'}
          disabled={disabled} />}
        <I18nInput
          store={store}
          label={store.__('Text')}
          attrs={entity.get('transls')}
          name='transls'
          optionsMap={store.options}
          onChange={handleChange}
          errors={errors}
          onAdd={handleAdd}
          onRemove={handleRemove} disabled={disabled}
          tablang={tablang} />
        <TextInput
          attr={'value'}
          disabled={disabled || hasID || entity.get('checkAuto')}
          errors={errors}
          label={store.__('Key')}
          onChange={updateField}
          record={entity} />
        {!hasID && <Checkbox checked={entity.get('checkAuto')} attr='checkAuto' onChange={handleCheckboxChange}>
          {store.__('Auto-generated key from text')}
        </Checkbox>}
        {entityName === linkConst.LINK_TIERS_SETTINGS && !hasID &&
          <div><br />
            <p className='alert alert-warning'>
              <strong>{store.__('Beware!')}</strong>&nbsp;
              {store.__('For a subscription add "_svod" at the end of key.')}<br />
              {store.__('(e.g. for "TIZAMA Subscription" is key value "tizama_svod")')}
            </p>
          </div>}
      </div>
      <div className='col-xs-12 col-sm-9 col-md-6'>
        {entityName !== linkConst.LINK_TIERS_SETTINGS && !hasID && listOfCategories(entity.get('fp_platform_code'))}
        {entityName === linkConst.LINK_TIERS_SETTINGS && !hasID && listOfTiers(entity.get('value'))}
      </div>
    </div>
  )
})

EnumsSetEditForm.propTypes = {
  store: PropTypes.object.isRequired
}

const EnumsSetEditView = ({ store }) => {
  const entityName = store.router && store.router.params && store.router.params.entityname
  if (!store.hasRight(entityName)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(entityName, 'w')} >
      <EnumsSetEditForm store={store} />
    </EditView>
  )
}
export default observer(EnumsSetEditView)
